import React from "react";

export default class LogoutService extends React.Component {

	userLogout() {
	    localStorage.clear();

	    var cookies = document.cookie.split(";");

	    for (var i = 0; i < cookies.length; i++) {
	        var cookie = cookies[i];
	        var eqPos = cookie.indexOf("=");
	        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;

	        document.cookie = name+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
	    }

	    location.reload();
	}
}


// WEBPACK FOOTER //
// ./src/components/LogoutService.js